import { inquiryRepository } from '~/api/repository/inquiry';

export const INQUIRY_QUERY_KEY = {
  all: ['inquiry'] as const,

  // 내 상품문의 목록 조회 (무한 스크롤)
  myList: () => ({
    queryKey: ['/api/market-place/v1/product-inquiries'] as const,
    queryFn: ({ pageParam }: { pageParam?: number } = {}) =>
      inquiryRepository.getMyInquiries({ lastInquiryId: pageParam }),
    infinite: true,
  }),
};

// Mutation Keys (캐시 무효화에 사용)
export const INQUIRY_MUTATION_KEY = {
  edit: () => [...INQUIRY_QUERY_KEY.all, 'edit'] as const,
  delete: () => [...INQUIRY_QUERY_KEY.all, 'delete'] as const,
};
